import { render, staticRenderFns } from "./RevisionForm.vue?vue&type=template&id=7a28fe33"
import script from "./RevisionForm.vue?vue&type=script&lang=js"
export * from "./RevisionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports